module.exports = function() {
  return new Worker(__webpack_public_path__ + "469e145425f7c6342e70.worker.js");
};